export function applyHeaderFromTokenResponse(tokenResponse, headers, rpsCompactPrefix) {
    if (!tokenResponse || !tokenResponse.success) {
        return headers !== null && headers !== void 0 ? headers : {};
    }
    if (!headers) {
        headers = {};
    }
    var headerPrefix = tokenResponse.format === 'RPSCompact'
        ? rpsCompactPrefix || ''
        : 'Bearer ';
    // BUGBUG: Safari does not like headers with trailing space. Have to trim it explicitly
    // because token can be empty in mock scenarios.
    headers['Authorization'] = "".concat(headerPrefix).concat(tokenResponse.token).trim();
    return headers;
}
//# sourceMappingURL=applyHeaderFromTokenResponse.js.map